module.exports = __webpack_public_path__ + "img/d76a4986080fec238a19dadc779f54f2.png";